export const BASE = (process.env.REACT_APP_TOTO_API_URL || "").replace(/\/+$/, "");
export const API = `${BASE}/api`;
const LOCAL_API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "cardconnect.auth.token";
export const ADMIN_KEY = "cardconnect.admin.token";
export const OWNER_EMAIL = "salumurisaikrishna@gmail.com";

export class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

async function request(path, { method = "GET", body, admin = false, form, local = false } = {}) {
  const token = localStorage.getItem(admin ? ADMIN_KEY : TOKEN_KEY);
  const headers = {};
  if (!form) headers["Content-Type"] = "application/json";
  if (token && path !== "/admin/login") headers.Authorization = `Bearer ${token}`;
  let res;
  try {
    res = await fetch((local ? LOCAL_API : API) + path, { method, headers, body: form ?? (body !== undefined ? JSON.stringify(body) : undefined) });
  } catch {
    throw new ApiError("Network error. Please check your connection.", 0);
  }
  if (!res.ok) {
    let detail = res.status === 404 || res.status >= 500 ? "TOTO server is unavailable right now. Please try again in a moment." : "Something went wrong. Please try again.";
    try {
      const j = await res.json();
      if (typeof j?.detail === "string") detail = j.detail;
      else if (Array.isArray(j?.detail) && j.detail[0]?.msg) detail = j.detail[0].msg;
    } catch {}
    if (token && admin && (res.status === 401 || res.status === 403)) {
      localStorage.removeItem(ADMIN_KEY);
      window.dispatchEvent(new Event("toto-admin-cleared"));
    }
    if (token && !admin && !local && res.status === 401 && !path.startsWith("/auth/login")) {
      window.dispatchEvent(new Event("toto-session-expired"));
    }
    throw new ApiError(detail, res.status);
  }
  if (res.status === 204) return null;
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

const make = (admin) => ({
  get: (p, o) => request(p, { admin, ...o }),
  post: (p, b) => request(p, { method: "POST", body: b, admin }),
  patch: (p, b) => request(p, { method: "PATCH", body: b, admin }),
  put: (p, b, o) => request(p, { method: "PUT", body: b, admin, ...o }),
  del: (p) => request(p, { method: "DELETE", admin }),
  upload: (p, form) => request(p, { method: "POST", form, admin }),
});

export const api = make(false);
export const adminApi = make(true);

export function guestProcessScan(front, force) {
  const form = new FormData();
  form.append("file", front, `guest-${Date.now()}.jpg`);
  form.append("force", force ? "true" : "false");
  return api.upload("/scans/guest-process", form);
}

export function processScan(front, back, force) {
  const form = new FormData();
  form.append("file", front, `front-${Date.now()}.jpg`);
  if (back) form.append("back", back, `back-${Date.now()}.jpg`);
  form.append("force", force ? "true" : "false");
  return api.upload("/scans/process", form);
}
